import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { putRequest } from '../../httpClient';
import type { IUpdateEnglishIqDemoV1Request } from './update-english-iq-demo-v1-request';
import type { IUpdateEnglishIqDemoV1Response } from './update-english-iq-demo-v1-response';
import { updateEnglishIqDemoV1ResponseSchema } from './update-english-iq-demo-v1-response';

export async function updateEnglishIqDemoV1Api(
  body: IUpdateEnglishIqDemoV1Request,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IUpdateEnglishIqDemoV1Response>> {
  return putRequest<IUpdateEnglishIqDemoV1Response>({
    body,
    options,
    path: '/sys/english-iq/demo/v1',
    schema: updateEnglishIqDemoV1ResponseSchema,
  });
}
